import React from 'react';
import styles from './LeagueGroupTable.module.css';

const LeagueGroupTable = ({ standings, promoted, relegated, compact = false }) => {
    if (!standings || standings.length === 0) return null;

    const hasResults = standings.some(s => s.matchesPlayed > 0);

    const getRowClass = (index, standing) => {
        if (standing.frozen) return styles.frozen;
        if (!hasResults) return '';
        if (promoted === 0 && relegated === 0) return '';

        // Frozen players don't count for promotion/relegation positions
        const activeStandings = standings.filter(s => !s.frozen);
        const activeIndex = activeStandings.indexOf(standing);
        if (activeIndex < 0) return '';

        if (promoted > 0 && activeIndex < promoted) {
            return styles.promoted;
        }

        if (relegated > 0 && activeIndex >= activeStandings.length - relegated) {
            return styles.relegated;
        }

        return '';
    };

    return (
        <div className={`${styles.container} ${compact ? styles.compact : ''}`}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Zawodnik</th>
                        <th>M</th>
                        <th>W</th>
                        <th>P</th>
                        <th>Sety</th>
                        <th>+/-</th>
                        <th>Pkt</th>
                    </tr>
                </thead>
                <tbody>
                    {standings.map((s, index) => (
                        <tr key={s.participantId} className={getRowClass(index, s)}>
                            <td>{s.rank}</td>
                            <td className={styles.playerName}>
                                {s.frozen && <span title="Zamrożony">&#10052;&#65039; </span>}
                                <div>{s.playerName}</div>
                                {s.partnerName && <div className={styles.partnerLine}>{s.partnerName}</div>}
                            </td>
                            <td>{s.matchesPlayed}</td>
                            <td>{s.wins}</td>
                            <td>{s.losses}</td>
                            <td>{s.setsWon}:{s.setsLost}</td>
                            <td className={getBalanceClass(s.smallPointsWon - s.smallPointsLost, styles)}>
                                {formatBalance(s.smallPointsWon - s.smallPointsLost)}
                            </td>
                            <td className={styles.points}>{Number(s.points).toFixed(1)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

function formatBalance(balance) {
    return balance > 0 ? `+${balance}` : `${balance}`;
}

function getBalanceClass(balance, styles) {
    if (balance > 0) return styles.positive;
    if (balance < 0) return styles.negative;
    return '';
}

export default LeagueGroupTable;
